import { render, staticRenderFns } from "./FixedAmount.vue?vue&type=template&id=958ec474&"
import script from "./FixedAmount.vue?vue&type=script&lang=js&"
export * from "./FixedAmount.vue?vue&type=script&lang=js&"
import style0 from "./FixedAmount.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports